<div class="animated fadeIn">
  <div class="row">
    <div class="col-md-12">
      <div class="header">{{"to_generate.title" | translate}}</div>
    </div>
  </div>

  <ul class="nav nav-tabs mb-3">
    <li class="nav-item">
      <div
        class="tab-link tab-label"
        routerLinkActive="active"
        routerLink="classic"
      >
        {{ 'to_generate.tabs.classic' | translate }}
      </div>
    </li>
    <li class="nav-item">
      <div
        class="tab-link tab-label"
        routerLinkActive="active"
        routerLink="electronic"
      >
        {{ 'to_generate.tabs.electronic' | translate }}
      </div>
    </li>
  </ul>

  <router-outlet></router-outlet>
</div>
